import React from 'react';

import { classNames } from '@/helpers/classNames';

import styles from '../Onboarding.module.scss';

const InnerStepFive: React.FC = () => {
	return (
		<>
			<div className={styles['heading']}>
				<img
					className={styles['svg']}
					src="/assets/onboarding-icons/refresh.svg"
				/>
				Grow every week
			</div>
			<div className={classNames([styles['text'], 'mt-sm'])}>
				Add people and complete the cycle together. Help your team grow
				so your church can too.
			</div>
		</>
	);
};

export default InnerStepFive;
